import { useLayoutEffect, useRef, useState } from 'react';

export const useElementHeight = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [refHeight, setRefHeight] = useState<number>(0);

  useLayoutEffect(() => {
    const updateHeight = () => {
      if (ref.current) {
        setRefHeight(ref.current.getBoundingClientRect().height);
      }
    };

    const resizeObserver = new ResizeObserver(updateHeight);

    if (ref.current) {
      resizeObserver.observe(ref.current);
      updateHeight();
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return { ref, refHeight };
};
